import {
  TransactionOriginalStatus,
  TransactionOriginalStatusMeta,
} from "./types";

export const TRANSACTION_ORIGINAL_STATUS_META: Record<
  TransactionOriginalStatus,
  TransactionOriginalStatusMeta
> = {
  PENDING: {
    label: "Принята в очередь",
    erpDescription: "Принята в очередь",
    canBeClosed: true,
  },

  IN_PROGRESS: {
    label: "В процессе",
    erpDescription: "В процессе",
    canBeClosed: false,
  },

  VERIFICATION: {
    label: "В процессе",
    erpDescription: "В процессе.",
    canBeClosed: false,
  },

  DECREASE_VERIFICATION: {
    label: "В процессе",
    erpDescription: "Перевод не успешен. Выполняется возврат.",
    canBeClosed: false,
  },

  ABORTION_IN_PROGRESS: {
    label: "В процессе",
    erpDescription: "Перевод не успешен. Выполняется возврат",
    canBeClosed: false,
  },

  ABORTION_VERIFICATION: {
    label: "В процессе",
    erpDescription: "Перевод не успешен. Выполняется возврат",
    canBeClosed: false,
  },

  ABORTION_FAILED: {
    label: "В процессе",
    erpDescription: "Перевод не успешен. Выполняется возврат",
    canBeClosed: false,
  },

  UNVERIFIED: {
    label: "Не подтвержена",
    erpDescription: "Выполнена, ждем подтверждения выполнения операции.",
    canBeClosed: true,
  },

  DECREASE_UNVERIFIED: {
    label: "Не подтвержена",
    erpDescription: "Перевод выполнен, ждем подтверждения выполнения операции",
    canBeClosed: true,
  },

  ABORTION_UNVERIFIED: {
    label: "Не подтвержена",
    erpDescription:
      "Перевод не успешен. Деньги вернули, но ждем подтверждения.",
    canBeClosed: true,
  },

  MANUAL_VERIFICATION: {
    label: "Не подтвержена",
    erpDescription:
      "Не успешно. Ошибка не установлена. Отправлено на ручную проверку в GATE",
    canBeClosed: true,
  },

  SUCCESSFUL: {
    label: "Выполнено",
    erpDescription: "Выполнено успешно.",
    canBeClosed: false,
  },

  CLOSED_MANUALLY: {
    label: "Закрыта GATE",
    erpDescription: "Закрыта GATE. Результат уточняйте.",
    canBeClosed: false,
  },

  CLOSED_BY_AGENCY: {
    label: "Закрыта ФП",
    erpDescription: "Закрыта ФП. Ручной перевод в нужный статус.",
    canBeClosed: false,
  },

  CANCELLED: {
    label: "Не выполнено",
    erpDescription: "Операция не выполнена.",
    canBeClosed: false,
  },

  FAILED: {
    label: "Не выполнено",
    erpDescription: "Операция не выполнена.",
    canBeClosed: false,
  },

  ABORTED: {
    label: "Не выполнено",
    erpDescription: "Перевод прерван. Все возвращено к исходному состоянию.",
    canBeClosed: false,
  },

  ERROR: {
    label: "Не выполнено",
    erpDescription: "Прервана. Требует проверки и перевода в нужный статус.",
    canBeClosed: false,
  },
};
